import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, AnimateTimings, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { Subscription } from 'rxjs';
import { MyDocsService } from '../../service/mydocs.service';
import { MyDocsModel } from '../../models/upload/mydocs.model';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { TranslateTableModel } from '../../models/config/translate_table.model';
import { TranslateTableService } from '../../service/translate_table.service';
import { ManageUserService } from 'src/app/service/manage-user.service';



@Component({
  selector: 'app-employee-document',
  templateUrl: './employee-document.component.html',
  styleUrls: ['./employee-document.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class EmployeeDocumentComponent implements OnInit {
  public transModel = new TranslateTableModel();
  public fname: string;
  public fieldData: TranslateTableModel[] = [];
  public document_name: string;
  public document_content: string;
  public aaa: string;
  public document: string;
  public src: any;
  public content: string;
  public status: boolean = false;
  public approvedStatus: string = "Pending";
  public isChecked: boolean = false;
  public isApproved: boolean = false;
  public docid: number = 0;
  public isSubmit: boolean = false;
  public isClickedOutside: boolean = false;



  public myDocsModel = new MyDocsModel();

  public showLoading: boolean;
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public loggedinUser: string = '';

  myDocsData: MyDocsModel[] = [];
  excelMyDocsData: MyDocsModel[] = [];

  public dataSource = new MatTableDataSource<MyDocsModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild('showdiv') showdiv: ElementRef<HTMLElement>;

  @ViewChild("insideElement") insideElement;
  @HostListener('click', ['$event'])
  public clickout(event) {
    if (this.insideElement.nativeElement.contains(event.target)) {
      if (!this.isClickedOutside) {
        console.log("clicked inside");
      }


    } else {
      console.log("clicked outside");
      this.isClickedOutside = true;
    }
  }

  public displayedColumns = ['doc_name', 'doc_desc', 'status', 'view', 'download'];

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  // GRID FRAMEWORK
  ordersTableColumns1: TableColumn[];
  columnsData: any;
  actions: any;
  loginUser: string = "";


  constructor(private httpService: HttpClient, private myDocsService: MyDocsService,
    public ete: ExportExcelService, private manageUserService: ManageUserService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService, private translateTableService: TranslateTableService, private eRef: ElementRef) { }

  ngOnInit(): void {

    this.loggedinUser = this.authGaurdService.loginUser();
    console.log(' login name ', this.loggedinUser);
    this.getEmpDocsList();
    this.initializeColumns();
    this.initializeExcelHeaders();

   // console.log(localStorage.getItem('CURRENT_USER_NAME_SESSION'));
    this.loginUser = localStorage.getItem('CURRENT_USER_NAME_SESSION');
   // console.log(this.loginUser);

   // console.log("Impersonate Status: " + this.authGaurdService.isImpersonate);
   // console.log("Impersonate Logged In User1: " + this.authGaurdService.loggedInEmployeeId);
   // console.log("Impersonate Logged In User2: " + localStorage.getItem('imperloggedInEmployeeId'));
  }

  public getEmpDocsList(): void {
    this.myDocsService.getEmployeeDocsList(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')).subscribe(
      (response: MyDocsModel[]) => {
        //this.dataSource.data = response as MyDocsModel[];
        this.myDocsData = response;
        this.excelMyDocsData = JSON.parse(JSON.stringify(response));
        console.log("mydocsdata" + this.excelMyDocsData);
        this.myDocsData = this.myDocsData.sort((a, b) => (a.doc_name < b.doc_name) ? -1 : 1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  initializeExcelHeaders(): void {

    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.myDocs;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    //console.log("called exportExcel" + JSON.stringify(this.excelMyDocsData));
    for (let js of this.excelMyDocsData) {
      delete js.id;
      delete js.comm_doc_str;
      delete js.editMode;
      delete js.comm_doc;
      delete js.comm_plan_id;
      delete js.user_type;
      delete js.effective_dt;
      delete js.employeeId;
      delete js.employeeName;
      delete js.employeesList;
      delete js.created_dt;
      delete js.created_by;
      delete js.selected;
      delete js.updated_by;
      delete js.updated_dt;
      delete js.comment;
      delete js.sc_emp_id;
      delete js.status;
      delete js.salesChannel;
      delete js.salesChannelDesc;
      delete js.uploadedDt;
    }

    this.dataForExcel = [];
    let reportData = null;
    this.excelMyDocsData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row));
    })
    reportData = {
      title: 'MyDocs',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  popPdf(comm_doc: any, doc_name: string) {

    this.src = this._base64ToArrayBuffer(comm_doc);
    this.clickButton('openNameEdit');
    this.document_name = doc_name;
    this.document_content = comm_doc;

    // this.ngAfterViewInit();
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }


  downloadPdf(comm_doc: string, doc_name: string) {
    const linkSource = 'data:application/pdf;base64,' + comm_doc;
    const downloadLink = document.createElement("a");
    const fileName = doc_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  // GRID FRAMEWORK

  rowAction(row: any) {
    if (row.value === 'View') {
      this.popPdf(row.row.comm_doc_str, row.row.doc_name)
      this.docid = row.row.id;
      //this.isActive=true;
      this.document_content = row.row.comm_doc_str;
      this.document_name = row.row.doc_name;
      this.isChecked = false;
      this.approvedStatus = row.row.approved_status;
     // console.log(this.approvedStatus);

      if (this.approvedStatus === "Approved") {
        this.isApproved = false;
        console.log(this.isApproved);
      } else {
        this.isApproved = true;
      }
      this.ngOnInit();
    }
    if (row.value === 'Download') {
      this.downloadPdf(row.row.comm_doc_str, row.row.doc_name)
    }

  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  getCheckBox(event: any) {
    this.isChecked = event.target.checked;

  }

  public submitStatus(status: string): void {
   // console.log(status);
   // console.log(localStorage.getItem('CURRENT_USER_NAME_SESSION'));
    this.isSubmit = true;
    if (this.isChecked === true) {
      const formData = this.myDocsService.createForm(this.docid, status);
      this.myDocsService.submitStatus(formData).subscribe(
        (response: MyDocsModel) => {
          this.clickButton('closeEditFiledNameModalButton');
          this.getEmpDocsList();
          var statusmsg: any;
          statusmsg = status + " Successfully";
          this.notificationService.sendNotification(NotificationType.SUCCESS, statusmsg);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
      this.isChecked = false;
    }

    else {
      this.notificationService.sendNotification(NotificationType.ERROR, `Please check the acknowledgement`);
    }
  }



  public getTransList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.translateTableService.getTransList().subscribe(
        (response: TranslateTableModel[]) => {
          this.fieldData = response;
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
          this.refreshing = false;
        }
      )
    );
  }

  popDownload() {
   // console.log("popDownload()");
    const linkSource = 'data:application/pdf;base64,' + this.document_content;
    const downloadLink = document.createElement("a");
    const fileName = this.document_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  doSubmit() {
    console.log("doSubmit()");
    if (this.isChecked == true && this.isSubmit == false) {
      this.notificationService.sendNotification(NotificationType.ERROR, `You forget to Submit the Document`);

    }

  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns1 = this.columnsData.empDocs;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'View',
        dataKey: 'fas fa-eye primary f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      },
      {
        name: 'Download',
        dataKey: 'fas fa-download success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]
  }

}

